/*
 * @Description: mark
 * @Author: wangwangwang
 * @Date: 2020-08-06 10:30:49
 * @LastEditors: wangwangwang
 * @LastEditTime: 2020-09-05 18:15:08
 */
import request from '@/utils/request'

export function backlogQueryPage(data) {
	return request({
		url: '/workflow/system/sign/task/center/backlogQueryPage', 
		method: 'post',
		data
	})
}
export function dueOutQueryPage(data) {
	return request({
		url: '/workflow/system/sign/task/center/dueOutQueryPage', 
		method: 'post',
		data
	})
}
export function myOutTaskQueryPage(data) {
	return request({
		url: '/workflow/system/sign/task/center/myOutTaskQueryPage', 
		method: 'post',
		data
	})
}
export function submitTaskQueryPage(data) {
	return request({
		url: '/workflow/system/sign/task/center/submitTaskQueryPage', 
		method: 'post',
		data
	})
}
export function finishedTaskQueryPage(data) {
	return request({
		url: '/workflow/system/sign/task/center/finishedTaskQueryPage', 
		method: 'post',
		data
	})
}
export function collectQueryPage(data) {
	return request({
		url: '/workflow/system/sign/task/center/collectQueryPage', 
		method: 'post',
		data
	})
}
export function tailAfterTaskQueryPage(data) {
	return request({
		url: '/workflow/system/sign/task/center/tailAfterTaskQueryPage', 
		method: 'post',
		data
	})
}
/*撤销*/
export function revocationTask(data) {
	return request({
		url: '/workflow/system/sign/task/center/revocationTask', 
		method: 'post',
		data
	})
}
/*收藏*/
export function taskCollectByUser(data) {
	return request({
		url: '/workflow/system/sign/task/collect/taskCollectByUser', 
		method: 'post',
		data
	})
}
/*回收*/
export function recycleTask(data) {
	return request({
		url: '/workflow/system/sign/task/center/recycleTask', 
		method: 'post',
		data
	})
}